import React from 'react';
import { CheckCircle, Gift } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function OfferSection() {
  const handleBuyClick = e => {
    // Track AddToCart event
    trackAddToCart();
  };
  return <section id="inscripcion" className="py-16 px-4 md:px-8 lg:px-16 bg-white" data-id="element-209">
      <div className="max-w-7xl mx-auto" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900" data-id="element-212">
            Eleva Tu Frecuencia Vibratoria Hoy
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-213">
            Transforma tu energía y tu vida con el programa completo 30 Días
            Frecuencia Prohibida
          </p>
        </div>
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8 md:p-12 shadow-xl mb-16" data-id="element-214">
          <div className="flex flex-col md:flex-row" data-id="element-215">
            <div className="md:w-2/3 md:pr-12 mb-8 md:mb-0" data-id="element-216">
              <h3 className="text-2xl md:text-3xl font-bold mb-6 text-indigo-900" data-id="element-217">
                El Programa Completo Incluye:
              </h3>
              <ul className="space-y-4" data-id="element-218">
                {['Acceso completo a las 4 audio sesiones de entrenamiento con frecuencias binaurales específicas', 'Manual completo con todos los protocolos y técnicas', 'Audios especializados para cada objetivo (abundancia, salud, relaciones)', 'Meditaciones guiadas para acceder a estados theta a voluntad', 'Bonus exclusivo: Frecuencia "Diamante" para protección energética', '1 Masterclasses adicional sobre control mental avanzado (VALOR: $197)', 'Acceso a la comunidad secreta de usuarios (VALOR: $97)'].map((item, index) => <li key={index} className="flex items-start" data-id="element-219">
                    <CheckCircle size={24} className="text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-220" />
                    <span className="text-lg" data-id="element-221">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-10 border-t border-indigo-200 pt-10" data-id="element-222">
                <h4 className="flex items-center text-xl font-bold mb-6 text-indigo-900" data-id="element-223">
                  <Gift size={24} className="mr-3 text-indigo-600" data-id="element-224" />
                  BONUS INCLUIDOS:
                </h4>
                <p className="text-lg mb-6" data-id="element-225">
                  Paga solo ARS $39.195,00 hoy y recibe acceso inmediato a todo
                  el programa más los bonos exclusivos.
                </p>
              </div>
            </div>
            <div className="md:w-1/3 bg-white rounded-xl p-6 shadow-lg" data-id="element-226">
              <div className="text-center mb-6" data-id="element-227">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cg1U4PVqHewz5V8GNzsiiJ/Generated_Image_September_13%2C_2025_-_2_01AM_%281%29.png" alt="Programa 30 Días Frecuencia Prohibida" className="w-full h-auto rounded-lg mb-4 shadow-md" data-id="element-228" />
                <div className="text-sm font-bold text-indigo-600 mb-2" data-id="element-229">
                  OFERTA DE ACCESO EXCLUSIVO
                </div>
                <div className="flex items-center justify-center" data-id="element-230">
                  <div className="text-gray-400 line-through text-lg" data-id="element-231">
                    ARS $78.590,00
                  </div>
                  <div className="ml-3 bg-yellow-400 text-indigo-900 text-sm font-bold px-2 py-1 rounded" data-id="element-232">
                    AHORRA 50%
                  </div>
                </div>
                <div className="text-4xl font-bold text-indigo-900 my-2" data-id="element-233">
                  ARS $39.195,00
                </div>
                <div className="text-sm text-gray-600 mb-4" data-id="element-234">
                  Pago único - Acceso completo
                </div>
              </div>
              <div className="space-y-4" data-id="element-235">
                <a href="https://pay.hotmart.com/W101883420N" target="_blank" rel="noopener noreferrer" className="block w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 px-6 rounded-lg text-center transition-all uppercase" onClick={handleBuyClick} data-id="element-236">
                  Desclasificar Acceso Ahora
                </a>
              </div>
              <div className="mt-6 text-center" data-id="element-237">
                <div className="flex justify-center mb-2" data-id="element-238">
                  <img src="https://cdn-icons-png.flaticon.com/512/6214/6214904.png" alt="Pago seguro" className="h-8" data-id="element-239" />
                </div>
                <p className="text-sm text-gray-600" data-id="element-240">
                  Pago 100% seguro. Aceptamos tarjetas de crédito, débito y
                  PayPal.
                </p>
              </div>
              <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-241">
                <div className="flex items-center justify-center mb-4" data-id="element-242">
                  <div className="bg-indigo-900 text-white rounded-full w-16 h-16 flex items-center justify-center mr-3" data-id="element-243">
                    <span className="text-2xl font-bold" data-id="element-244">7</span>
                  </div>
                  <div className="text-left" data-id="element-245">
                    <div className="font-bold text-indigo-900" data-id="element-246">
                      Días de Garantía
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-247">
                      Satisfacción total o devolución
                    </div>
                  </div>
                </div>
                <p className="text-sm text-center text-gray-700" data-id="element-248">
                  Si en 7 días no experimentas resultados, te devolvemos el 100%
                  de tu dinero.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-249">
          <p className="text-lg font-bold text-indigo-900 mb-2" data-id="element-250">
            ¡IMPORTANTE! OFERTA DISPONIBLE SOLO POR 24 HORAS
          </p>
          <p className="text-gray-700 mb-8" data-id="element-251">
            Los bonos exclusivos y el precio especial solo estarán disponibles
            durante las próximas 24 horas
          </p>
          <a href="https://pay.hotmart.com/W101883420N" target="_blank" rel="noopener noreferrer" className="inline-block bg-yellow-500 hover:bg-yellow-400 text-indigo-900 font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105 uppercase" onClick={handleBuyClick} data-id="element-252">
            Desclasificar Acceso Ahora
          </a>
        </div>
      </div>
    </section>;
}